import { render, staticRenderFns } from "./popup-do-mu-ban.vue?vue&type=template&id=3253b7da&scoped=true"
import script from "./popup-do-mu-ban.vue?vue&type=script&lang=js"
export * from "./popup-do-mu-ban.vue?vue&type=script&lang=js"
import style0 from "./popup-do-mu-ban.vue?vue&type=style&index=0&id=3253b7da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3253b7da",
  null
  
)

export default component.exports